import { List } from './List';
import { ReportComponent } from './ReportComponent';
import { User } from './User';
import { Workspace } from './Workspace';

export enum ConnectedAccountType {
    // Email & Calendar
    GMAIL = 'Gmail',
    MICROSOFT_365_OUTLOOK = 'Microsoft 365 Outlook',
    // Document Storage
    GOOGLE_DRIVE = 'Google Drive',
    MICROSOFT_ONEDRIVE = 'OneDrive',
    MICROSOFT_SHAREPOINT = 'Microsoft SharePoint',
    BOX = 'Box',
    DROPBOX = 'Dropbox',
    ZOHO_WORKDRIVE = 'Zoho Workdrive',
    // Communication
    SLACK = 'Slack',
    MICROSOFT_TEAMS = 'Microsoft Teams',
    // Productivity
    AIRTABLE = 'Airtable',
    ASANA = 'Asana',
    WRIKE = 'Wrike',
    MICROSOFT_ONENOTE = 'Microsoft OneNote',
    NOTION = 'Notion',
    CLICKUP = 'ClickUp',
    MONDAY = 'Monday.com',
    CODA = 'Coda',
    CONFLUENCE = 'Confluence',
    DOCUSIGN = 'DocuSign',
    ADOBE_ACROBAT_SIGN = 'Adobe Acrobat Sign',
    GOOGLE_SHEETS = 'Google Sheets',
    MIRO = 'Miro',
    SMARTSHEET = 'Smartsheet',
    ZOHO_PROJECTS = 'Zoho Projects',
    // CRM
    SALESFORCE = 'Salesforce',
    HUBSPOT = 'HubSpot',
    ATTIO = 'Attio',
    PIPEDRIVE = 'Pipedrive',
    WEALTHBOX = 'Wealthbox',
    CLOSE = 'Close',
    ZOHO_CRM = 'Zoho CRM',
}

export interface ConnectedAccount {
    id: string;
    user: User;
    workspace: Workspace;
    type: ConnectedAccountType | undefined;
    nickname: string | undefined;
    accessToken: string | undefined;
    refreshToken: string | undefined;
    nylasGrantId: string | undefined;
    metadata: Record<string, unknown> | undefined;
    list: List;
    reportComponents: ReportComponent[];
    expiresAt: Date | undefined;
    createdAt: Date;
    updatedAt: Date;
}
